var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "ArrowDown",

    getDefaultProps () {
        return {"width":"18px","height":"18px","viewBox":"0 0 18 18","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>Artboard</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Artboard" strokeWidth="2" stroke="currentColor">
      <g id="arrow-right" transform="translate(9.500000, 9.000000) rotate(90.000000) translate(-9.500000, -9.000000) translate(7.000000, 4.000000)">
        <g id="icon-arrow-right-small">
          <g id="Page-1">
            <g id="icon-arrow-right-small">
              <polyline id="Back-Arrow-Copy-3" points="0 10 5 5 0 0"/>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/arrow-down.svg
 **/